import { render, staticRenderFns } from "./ComponentArchive.vue?vue&type=template&id=67cf94bc&"
import script from "./ComponentArchive.vue?vue&type=script&lang=js&"
export * from "./ComponentArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sam/code/unesco-digital-presentation/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67cf94bc')) {
      api.createRecord('67cf94bc', component.options)
    } else {
      api.reload('67cf94bc', component.options)
    }
    module.hot.accept("./ComponentArchive.vue?vue&type=template&id=67cf94bc&", function () {
      api.rerender('67cf94bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/ComponentArchive.vue"
export default component.exports